module.exports = __webpack_public_path__ + "static/quaals_feather_token_fan-79e303f32f0ba010c9e373aa7c646bfc.jpeg";